"use strict";

/**
 * @namespace helpers
 * @name ShinePrinting/Helpers
 */
function roundUp(quantity, divisor) {
  var y = Math.ceil(quantity / divisor);
  var x = y * Number(divisor);
  return x;
}

module.exports = roundUp;